import { FC, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  ChangeBgBtn,
  ProjectEditPageGridLabel,
  ProjectEditPageGridRow,
  ProjectEditPageGridRowBase,
  UserColorChoose,
  UserColorChooseBlock
} from "../../styles";
import { ColorElement, ColorPickerWrapper } from "./styles";
import { Colors, CommonLabelText } from "@brg/ui";
import { useSelector } from "react-redux";
import SketchPicker from "react-color/lib/components/sketch/Sketch";
import ClickAwayListener from "react-click-away-listener";
import { useRouteMatch } from "react-router-dom";
import { CompetitionEditPageGridLabel } from "_competition/pages/CreateCompetitionPage/stylesEdit";
import { ColumnLabelGroup } from "shared/pages/projectEdit/styles";

interface ColorPickerProps {
  onChange?: (color: string) => void
  value: string
  label?: string
  formLabel?: string
  vTYPE?: string
  isCompetition?: boolean
  isShort?: boolean
  isButtonColor?: boolean
  isProDeziiign?: boolean
  mobileLeftOffset?: string | number
  customAlignItems?: string
  showOnMobile?: boolean
  customPickerFirst?: boolean
  swatchColors?: string[]
}

export const STANDARD_COLOR_PICKER_SWATCHES: string[] = [
  Colors.gal, '#d52b1e', '#ffc19c', '#ffbc3d', '#bed600', '#3d7edb', '#aacae6', '#f5ec5a',
  '#000000', '#d1d4d3', '#5e6a71', '#e2ddcb', '#aea79f', '#bcd4c3', '#394a58',
];

const COLORS = STANDARD_COLOR_PICKER_SWATCHES

export const WIDE_SCREEN_COLORS = [Colors.gal, '#000000', '#d1d1d1'];

const ColorPicker: FC<ColorPickerProps> = ({
  value,
  onChange,
  vTYPE,
  isCompetition,
  isShort,
  label,
  formLabel,
  isButtonColor,
  isProDeziiign,
  mobileLeftOffset,
  customAlignItems,
  showOnMobile,
  customPickerFirst,
  swatchColors: swatchColorsProp
}) => {
  const { t } = useTranslation();
  const isTeamEdit = useRouteMatch('/team-edit');
  const vtype = useSelector((state: any) => state?.vt?.vtype);
  const colorPickerButton = useRef<HTMLDivElement>(null);
  const [picker, togglePicker] = useState(false);
  const isWideLongread = !isTeamEdit && !vTYPE && vtype === 'fluid';
  const isProjectEditPage = !!useRouteMatch(['/edit', '/books/edit'])

  const palette = swatchColorsProp?.length ? swatchColorsProp : COLORS

  const colorList = useMemo(() => {
    if (isWideLongread && !swatchColorsProp?.length) {
      return WIDE_SCREEN_COLORS.map((color) => (
        <ColorElement
          isCompetition={isCompetition}
          key={color}
          color={color}
          selected={value === color}
          currentBackground={value}
          onClick={() => onChange?.(color)}
        />
      ))
    }
    return palette?.filter((color) => {
      if (isShort) {
        return [Colors.gal, '#000000']?.includes(color)
      }

      return color;
    }).map((color) => {
      const clr = isCompetition && color === '#FEFEFE' ? '#343434' : color;

      return (
        <ColorElement
          isCompetition={isCompetition}
          key={clr}
          color={clr}
          selected={value === clr}
          currentBackground={value}
          onClick={() => onChange?.(clr)}
        />
      )
    })
  }, [value, onChange, isWideLongread, isCompetition, palette, swatchColorsProp]);

  let alignItems = isCompetition || isShort ? "center" : "flex-start"

  if (customAlignItems) {
    alignItems = customAlignItems
  }

  const showCustomPicker = !isWideLongread && !isButtonColor

  const customPicker = showCustomPicker ? (
    <UserColorChoose className={'user-color-choose'}>
      <ChangeBgBtn ref={colorPickerButton} onClick={() => togglePicker(!picker)} />
      {picker && (
        <ClickAwayListener
          onClickAway={({ target }) => {
            if (target !== colorPickerButton.current) {
              togglePicker(!picker)
            }
          }}
        >
          <UserColorChooseBlock
            mobileLeftOffset={mobileLeftOffset}
            $pickerAtStart={Boolean(customPickerFirst)}
          >
            <SketchPicker
              color={value}
              onChangeComplete={(color) => onChange?.(color.hex)}
              presetColors={palette}
              disableAlpha
            />
          </UserColorChooseBlock>
        </ClickAwayListener>
      )}
    </UserColorChoose>
  ) : null

  return (
    <ProjectEditPageGridRowBase
      direction={'row'}
      directionMobile={isShort ? 'row' : 'column'}
      className={showOnMobile ? undefined : 'mobile__hide'}
      align={alignItems}
      isProDeziiign={isProDeziiign}
    >
        {isCompetition
          ?
          <CompetitionEditPageGridLabel className={'color-picker-label'}>
            {t('project_edit.background')}
          </CompetitionEditPageGridLabel>
          :
          isShort ?
            <ProjectEditPageGridLabel>
              {label}
            </ProjectEditPageGridLabel>
            :
            <ProjectEditPageGridLabel>
              {formLabel ?? t('project_edit.background')}
            </ProjectEditPageGridLabel>}
        <ColorPickerWrapper>
          {customPickerFirst && customPicker}
          {colorList}
          {!customPickerFirst && customPicker}
        </ColorPickerWrapper>
    </ProjectEditPageGridRowBase>
  )
}

export default ColorPicker;
import { FC, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  ChangeBgBtn,
  ProjectEditPageGridLabel,
  ProjectEditPageGridRow,
  ProjectEditPageGridRowBase,
  UserColorChoose,
  UserColorChooseBlock
} from "../../styles";
import { ColorElement, ColorPickerWrapper } from "./styles";
import { Colors, CommonLabelText } from "@brg/ui";
import { useSelector } from "react-redux";
import SketchPicker from "react-color/lib/components/sketch/Sketch";
import ClickAwayListener from "react-click-away-listener";
import { useRouteMatch } from "react-router-dom";
import { CompetitionEditPageGridLabel } from "_competition/pages/CreateCompetitionPage/stylesEdit";
import { ColumnLabelGroup } from "shared/pages/projectEdit/styles";

interface ColorPickerProps {
  onChange?: (color: string) => void
  value: string
  label?: string
  formLabel?: string
  vTYPE?: string
  isCompetition?: boolean
  isShort?: boolean
  isButtonColor?: boolean
  isProDeziiign?: boolean
  mobileLeftOffset?: string | number
  customAlignItems?: string
  showOnMobile?: boolean
  customPickerFirst?: boolean
  swatchColors?: string[]
}

export const STANDARD_COLOR_PICKER_SWATCHES: string[] = [
  Colors.gal, '#d52b1e', '#ffc19c', '#ffbc3d', '#bed600', '#3d7edb', '#aacae6', '#f5ec5a',
  '#000000', '#d1d4d3', '#5e6a71', '#e2ddcb', '#aea79f', '#bcd4c3', '#394a58',
];

const COLORS = STANDARD_COLOR_PICKER_SWATCHES

export const WIDE_SCREEN_COLORS = [Colors.gal, '#000000', '#d1d1d1'];

const ColorPicker: FC<ColorPickerProps> = ({
  value,
  onChange,
  vTYPE,
  isCompetition,
  isShort,
  label,
  formLabel,
  isButtonColor,
  isProDeziiign,
  mobileLeftOffset,
  customAlignItems,
  showOnMobile,
  customPickerFirst,
  swatchColors: swatchColorsProp
}) => {
  const { t } = useTranslation();
  const isTeamEdit = useRouteMatch('/team-edit');
  const vtype = useSelector((state: any) => state?.vt?.vtype);
  const colorPickerButton = useRef<HTMLDivElement>(null);
  const [picker, togglePicker] = useState(false);
  const isWideLongread = !isTeamEdit && !vTYPE && vtype === 'fluid';
  const isProjectEditPage = !!useRouteMatch(['/edit', '/books/edit'])

  const palette = swatchColorsProp?.length ? swatchColorsProp : COLORS

  const colorList = useMemo(() => {
    if (isWideLongread && !swatchColorsProp?.length) {
      return WIDE_SCREEN_COLORS.map((color) => (
        <ColorElement
          isCompetition={isCompetition}
          key={color}
          color={color}
          selected={value === color}
          currentBackground={value}
          onClick={() => onChange?.(color)}
        />
      ))
    }
    return palette?.filter((color) => {
      if (isShort) {
        return [Colors.gal, '#000000']?.includes(color)
      }

      return color;
    }).map((color) => {
      const clr = isCompetition && color === '#FEFEFE' ? '#343434' : color;

      return (
        <ColorElement
          isCompetition={isCompetition}
          key={clr}
          color={clr}
          selected={value === clr}
          currentBackground={value}
          onClick={() => onChange?.(clr)}
        />
      )
    })
  }, [value, onChange, isWideLongread, isCompetition, palette, swatchColorsProp]);

  let alignItems = isCompetition || isShort ? "center" : "flex-start"

  if (customAlignItems) {
    alignItems = customAlignItems
  }

  const showCustomPicker = !isWideLongread && !isButtonColor

  const customPicker = showCustomPicker ? (
    <UserColorChoose className={'user-color-choose'}>
      <ChangeBgBtn ref={colorPickerButton} onClick={() => togglePicker(!picker)} />
      {picker && (
        <ClickAwayListener
          onClickAway={({ target }) => {
            if (target !== colorPickerButton.current) {
              togglePicker(!picker)
            }
          }}
        >
          <UserColorChooseBlock
            mobileLeftOffset={mobileLeftOffset}
            $pickerAtStart={Boolean(customPickerFirst)}
          >
            <SketchPicker
              color={value}
              onChangeComplete={(color) => onChange?.(color.hex)}
              presetColors={palette}
              disableAlpha
            />
          </UserColorChooseBlock>
        </ClickAwayListener>
      )}
    </UserColorChoose>
  ) : null

  return (
    <ProjectEditPageGridRowBase
      direction={'row'}
      directionMobile={isShort ? 'row' : 'column'}
      className={showOnMobile ? undefined : 'mobile__hide'}
      align={alignItems}
      isProDeziiign={isProDeziiign}
    >
        {isCompetition
          ?
          <CompetitionEditPageGridLabel className={'color-picker-label'}>
            {t('project_edit.background')}
          </CompetitionEditPageGridLabel>
          :
          isShort ?
            <ProjectEditPageGridLabel>
              {label}
            </ProjectEditPageGridLabel>
            :
            <ProjectEditPageGridLabel>
              {formLabel ?? t('project_edit.background')}
            </ProjectEditPageGridLabel>}
        <ColorPickerWrapper>
          {customPickerFirst && customPicker}
          {colorList}
          {!customPickerFirst && customPicker}
        </ColorPickerWrapper>
    </ProjectEditPageGridRowBase>
  )
}

export default ColorPicker;
